import React from 'react';

import RegulatoryCheckboxes from '@swf/components/RegulatoryCheckboxes/RegulatoryCheckboxes';
import Translation from '@swf/components/Translation/Translation';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import { TXTWCL_Terms_of_Service, TXTWCL_Your_Agreement } from './RMFTermsOfService.messages.json';

const RMFTermsOfService = () => (
  <Container
    page={RMFTermsOfService}
    headerProps={{ title: <Translation {...TXTWCL_Your_Agreement} /> }}
    pageTopTitle={<Translation {...TXTWCL_Terms_of_Service} />}
  >
    <fieldset>
      <RegulatoryCheckboxes variant="rmf" />
    </fieldset>
    <CTAButton />
  </Container>
);

RMFTermsOfService.displayName = 'RMFTermsOfService';

export default RMFTermsOfService;
